import { createStore } from 'dashboard/store/storeFactory';
import SmartCampaignsAPI from 'dashboard/api/smartCampaigns';

export const useSmartCampaignsStore = createStore({
  name: 'SmartCampaign',
  type: 'pinia',
  API: SmartCampaignsAPI,
});
